import React from 'react';

import { H5 } from '../Typography';

export const EmptyText: React.FC = ({ children }) => {
  return <H5>{children}</H5>;
};
